import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { useTheme } from "@mui/material";
import React__default, { forwardRef } from "react";
import MuiTabs from "../../../node_modules/@mui/material/Tabs/Tabs.es.js";
const Tabs = forwardRef(function Tabs2({
  children,
  color,
  variant,
  allowScrollButtonsMobile,
  textColor,
  indicatorColor,
  ...rest
}, ref) {
  const theme = useTheme();
  const selectedColor = color ? theme.palette[color].main : theme.palette.primary.main;
  return /* @__PURE__ */ jsx(MuiTabs, { variant: "scrollable", allowScrollButtonsMobile: true, ref, TabIndicatorProps: {
    style: {
      backgroundColor: selectedColor
    }
  }, ...rest, children: React__default.Children.map(children, (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
    color
  }) : null) });
});
export {
  Tabs
};
//# sourceMappingURL=tabs.es.js.map
